import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PasswordInput from '../components/PasswordInput';

export default function Signup() {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    const result = await register(name, password);

    if (!result.success) {
      if (result.statusCode === 409) {
        setError('Name already taken. Please choose a different name.');
      } else {
        setError(result.error);
      }
    }

    setLoading(false);
  };

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#1a1a1c',
    color: '#e8e6e3',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const cardStyle = {
    width: '100%',
    maxWidth: '400px',
    padding: '32px',
    background: '#2a2a2e',
    borderRadius: '8px',
    border: '1px solid #3a3a3e',
  };

  const titleStyle = {
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: '24px',
    textAlign: 'center',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    fontSize: '13px',
    color: '#999',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    background: '#1a1a1c',
    border: '1px solid #3a3a3e',
    borderRadius: '4px',
    color: '#e8e6e3',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px',
    background: '#e8a87c',
    color: '#1a1a1c',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.6 : 1,
  };

  const errorStyle = {
    padding: '10px',
    background: '#d4726a22',
    border: '1px solid #d4726a44',
    borderRadius: '4px',
    color: '#d4726a',
    fontSize: '13px',
  };

  const linkStyle = {
    textAlign: 'center',
    fontSize: '13px',
    color: '#999',
    marginTop: '16px',
  };

  const linkTextStyle = {
    color: '#e8a87c',
    textDecoration: 'none',
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={titleStyle}>Create Account</h1>

        {error && (
          <div style={errorStyle}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={formStyle}>
          <div>
            <label style={labelStyle}>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
              disabled={loading}
              style={inputStyle}
            />
          </div>

          <PasswordInput
            password={password}
            confirmPassword={confirmPassword}
            onPasswordChange={setPassword}
            onConfirmPasswordChange={setConfirmPassword}
          />

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div style={linkStyle}>
          Already have an account? <Link to="/login" style={linkTextStyle}>Log in</Link>
        </div>
      </div>
    </div>
  );
}
